import React from 'react';
import { observer } from 'mobx-react-lite';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { LanguagesState } from 'src/AppState/CmsState/LanguagesState/LanguagesState';
import { CmsTranslationsForm } from 'src/domains/layouts/shared/cms/translationsForm/CmsTranslationsForm';
import { SeoPageTranslationFormState } from 'src/main/cms/SeoManagement/SeoForm/SeoPageTranslationFormState';
import { SeoFormState } from 'src/main/cms/SeoManagement/SeoForm/SeoFormState';

interface PropsType {
    seoPageTranslationFormState: SeoPageTranslationFormState;
    seoFormState: SeoFormState;
    languagesState: LanguagesState;
    formId: number;
}

export const SeoPageTranslationsForm = observer(
    ({ seoPageTranslationFormState, languagesState, seoFormState, formId }: PropsType) => {
        const { title, shortDescription, fullDescription, language, isNewForm } = seoPageTranslationFormState;

        const formIdsLength = seoFormState.formsIds.length;
        const lastFormId = seoFormState.formsIds[formIdsLength - 1];
        const isLastForm = lastFormId === formId;
        const isButtonDisabled =
            lastFormId === undefined
                ? false
                : seoFormState.getTranslationFormStateById(lastFormId).language.value === '';
        const isAllLanguagesSelected =
            seoFormState.formsIds.length === languagesState.getNonDefaultLanguagesList().length;

        return (
            <CmsTranslationsForm
                formLanguage={language}
                handleDelete={(): Promise<void> => seoFormState.handleDeleteTranslation(language.value)}
                isModifyMode={seoFormState.isEditMode || seoFormState.isDuplicateMode}
                isNewForm={isNewForm}
                onClick={seoFormState.addLanguageForm}
                showButton={isLastForm && isAllLanguagesSelected === false}
                isDisabled={isButtonDisabled}
                languagesState={languagesState}
                allSelectedLanguages={seoFormState.allSelectedLanguages}
                setSelectedLanguages={seoFormState.setSelectedLanguages}
                handleShowDeletePopup={seoFormState.handleShowDeletePopup}
                handleHideDeletePopup={seoFormState.handleHideDeletePopup}
                showDeletePopup={seoFormState.showDeletePopup}
            >
                <Input
                    formInputState={title}
                    isEmpty={title.value === ''}
                    label='Title'
                />
                <Textarea
                    formState={shortDescription}
                    isEmpty={shortDescription.value === ''}
                    label='Short description'
                />
                <Textarea
                    formState={fullDescription}
                    isEmpty={fullDescription.value === ''}
                    label='Full description'
                    ckeditor
                />
            </CmsTranslationsForm>
        );
    }
);
